<template>
    <div class="sidebar-project"
    :style="{boxShadow: `inset 8px 0px 0px ${color}`}">

      <div class="sidebar-project-info">
        <h3>{{title}}</h3>
        <p>{{type}} • {{client}}</p>
        <p>{{year}}</p>
      </div>

      <div class="sidebar-project-image"
      :style="{backgroundImage: `url(img/thumbs/${slug}.jpg)`}" />

      <div class="sidebar-project-arrow">
        <svg width="25" height="19" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path :style="{stroke: color}" d="M1 9.5H24M24 9.5L15.701 2M24 9.5L15.701 17" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
        </svg>
      </div>

    </div>
</template>

<script>
export default {
  props: ['title', 'year', 'client', 'type', 'project', 'color', 'slug'],
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss">

.sidebar-project {
    background: $white;
    background-size: cover;
    width:100%;
    height: 100%;
    display: flex;
    text-align: left;
    justify-content: center;
    flex-direction: column;
    z-index: 99;
    position: relative;
    @extend %linkify;

    border: solid $gray2;
    border-width: 0px 1px 1px 0px;
    position: relative;
    overflow: hidden;

    @include tablet-below {
      min-width: 300px;
      height: 150px;
    }

    &:hover {

      .sidebar-project-info {
        transform: translateX(5px);

        h3, p {
          color: $black;
        }
      }

      .sidebar-project-image {
        opacity: .15;
      }

      .sidebar-project-arrow {
        bottom: 3px;
      }
    }

    .sidebar-project-info {
      padding-left: 15%;
      padding-right: 5%;
      transition: all .2s ease-out;

      h3 {
        font-family: $title-font;
        font-size: 1.125rem;
        margin-bottom: .25rem;
        color: $gray7;
        text-shadow:
        -1px -1px 0 $white,
        1px -1px 0 $white,
        -1px 1px 0 $white,
        1px 1px 0 $white;
      }

      p {
        font-size: .625rem;
        color: $gray4;
        text-transform: uppercase;
      }

      @include tablet-below {
        padding: 10% 5% 10% 20%;
      }
    }

    .sidebar-project-image {
      position: absolute;
      width: 100%;
      height: 100%;
      background-size: cover;
      z-index: -9;
      mix-blend-mode: hard-light;
      opacity: 0;
      transition: opacity .5s ease-out;
      box-shadow: inset 8px 0 $white;
    }

    .sidebar-project-arrow {
      position: absolute;
      bottom: -25px;
      right: 7px;
      transform: rotate(180deg);
      transition: all 0.5s cubic-bezier(0.18, 0.89, 0.54, 1.27);
    }

}

.sidebar-project-active {

  .sidebar-project-image {
    opacity: .15;
  }
  .sidebar-project-info {
    p {
      color: $black;
    }
  }
}

.see-all {
  background-color: $gray1;
  box-shadow: inset 8px 0px 0px $gray4;

  &:hover {

    .sidebar-project-info {

      h3 {
        color: $gray7;
      }
      p {
        color: $gray6;
      }
    }
  }

  .sidebar-project-info {

    h3 {
      color: $gray7;
      text-shadow: none;
    }

    p {
      color: $gray6;
    }
  }
}

</style>
